var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIngredientReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_1713)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2646 0.636353C13.6214 0.636353 12.2894 1.9684 12.2894 3.61156V5.09916H9.31418V8.07437C9.31418 8.89595 9.98021 9.56197 10.8018 9.56197H22.7026C23.5242 9.56197 24.1902 8.89595 24.1902 8.07437V5.09916H21.215V3.61156C21.215 1.9684 19.883 0.636353 18.2398 0.636353H15.2646ZM15.2646 5.09916C15.2646 4.27758 15.9306 3.61156 16.7522 3.61156C17.5738 3.61156 18.2398 4.27758 18.2398 5.09916C18.2398 5.92074 17.5738 6.58677 16.7522 6.58677C15.9306 6.58677 15.2646 5.92074 15.2646 5.09916Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6592 18.9697H14.341V26.8485C14.341 27.8526 13.5168 28.6667 12.5001 28.6667C11.4834 28.6667 10.6592 27.8526 10.6592 26.8485V18.9697Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6592 21.9091H23.341V26.8485C23.341 27.8526 22.5168 28.6667 21.5001 28.6667C20.4834 28.6667 19.6592 27.8526 19.6592 26.8485V21.9091Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36377 6.58677H7.82658V8.07437C7.82658 9.71753 9.15862 11.0496 10.8018 11.0496H22.7026C24.3458 11.0496 25.6778 9.71753 25.6778 8.07437V6.58677H30.1406V33.3636H3.36377V6.58677ZM8.81832 12.9091H16.182V14.1212H14.9547V26.8485C14.9547 28.1873 13.8557 29.2727 12.5001 29.2727C11.1445 29.2727 10.0456 28.1873 10.0456 26.8485V14.1212H8.81832V12.9091ZM17.8183 12.9091H25.182V14.1212H23.9547V26.8485C23.9547 28.1873 22.8557 29.2727 21.5001 29.2727C20.1445 29.2727 19.0456 28.1873 19.0456 26.8485V14.1212H17.8183V12.9091Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_1713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7273,
    height: 32.7273,
    fill: "white",
    transform: "translate(0.636475 0.636353)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredientReport);
export default __webpack_public_path__ + "static/media/IngredientReport.f6581f5e18d1023262ab4df396775f43.svg";
export { ForwardRef as ReactComponent };